import {TrainingPage} from "../../components/Public/TrainingPage";

export default function Training() {
    return <TrainingPage/>;
}
